module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "100px",
      "padding-bottom": "50px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("Gordon S. Dickson was born near Inverness, Scotland, but left at an early age when his family returned to Northern Ireland.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("He was educated at secondary and grammar schools, and scraped through English ‘O’ level, as essay writing was not his strength.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("He was employed in the civil service for several years but is now retired and has only recently taken up writing novels. "), _c('em', [_vm._v("An Impossible Quest: A Bartonshire Tale 2")]), _vm._v(" is his latest novel.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("He enjoys reading several genres of books but mainly historical and detective novels, and gardening.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("Other books by this author are:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('em', [_vm._v("Verdict Unknown")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('em', [_vm._v("The Sheriff of River Bend")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('em', [_vm._v("Des Pond, Special Agent")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('em', [_vm._v("The Wartime Adventures of Harry Harris")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('em', [_vm._v("– Bartonshire Tale 1")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_c('em', [_vm._v("Verdict Unknown, the Sequel")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0